import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

import {
  Button,
  CircularProgress,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Input,
  ClickAwayListener,
  IconButton,
  InputBase,
  Typography,
  Divider,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';

import {
  MuiPickersUtilsProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {
  convertPersianDigit2English,
  checkMatchMedia,
  OrderTransportationType,
  translate,
  removeEmptyValueObject,
  // removeEmptyValueObject,
  // flattenObject,
} from './helpers';
import { Status as OrderStatus } from '../pages/orders/interfaces';
import {
  OrderBundleStatus,
  Status as BundleStatus,
} from '../pages/bundles/interfaces';
import { Status as CenterStatus } from '../pages/centers/interfaces';
import { UserRole } from '../pages/users/interfaces';
import { Status as ParcelsState } from '../pages/parcels/interfaces';
import { Category } from '../pages/products/interfaces';
import { mdiClose, mdiPlus, mdiTuneVerticalVariant } from '@mdi/js';
import clsx from 'clsx';
import { mdiChevronLeft, mdiMagnify } from '@mdi/js/commonjs/mdi';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { flattenObject } from 'client-sdk/src/helpers';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

export type State = {
  classes: Function;
};
export type Props = {
  filters: Filter[];
  onFilter: any; //ToDo
  baseFilter: BaseFilter;
  filterValues: any;
  mainFiltersCount: number;
};

export type BaseFilter = {
  type:
  | 'input'
  | 'select'
  | 'checkbox'
  | 'date-picker'
  | 'number'
  | 'time-picker'
  | 'date-picker-time';
  id: string;
  placeholder: string;
};

export type Filter = {
  type:
  | 'input'
  | 'select'
  | 'checkbox'
  | 'date-picker'
  | 'number'
  | 'time-picker'
  | 'date-picker-time';
  id: string;
  label: string;
  placeholder?: string;
  data?:
  | OrderStatus[]
  | BundleStatus[]
  | UserRole[]
  | CenterStatus[]
  | ParcelsState[]
  | OrderTransportationType[]
  | OrderBundleStatus[]
  | Category[];
  translateType?:
  | 'Order'
  | 'Category'
  | 'Bundle'
  | 'UserRole'
  | 'CenterStatus'
  | 'ParcelsStatus'
  | 'FleetType'
  | 'EmploymentStatus'
  | 'VehicleType'
  | 'TransactionType'
  | 'TPL'
  | 'OrderBundleStatus'
  | 'FleetStatus';
  icon?: any;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
      '& .MuiSelect-root': {
        fontSize: '1rem !important',
      },
    },
    container: {
      '@media (max-width: 768px)': {
        width: '100%',
      },
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '1px 0',
      border: 'solid 1px #8a8a8a',
      // '@media (max-width: 480px)': {
      //   height: '50px',
      //   width: '100%',
      //   // marginLeft: '80px',
      // },
    },
    iconButton: {
      padding: 4,
      marginRight: '4px',
      position: 'absolute',
      top: 4,
      right: 0,
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '30px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    iconButton1: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'fixed',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      right: 0,
      bottom: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      border: 'solid 1px #8a8a8a',
      zIndex: 10,
      minHeight: '400px',
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      // '& .MuiInput-underline::before': {
      //   borderBottom: '1px solid #d8d8d8 !important',
      // },
    },
    inputWrapper: {
      // flex: 2,
    },
    icon: {
      color: '#8a8a8a',
    },
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function RenderFilters(props: Props) {
  const [checkboxValue, setCheckboxValue] = useState([] as any[]);
  const classes = useStyles();
  const [init, setInit] = useState({} as any);
  const { filters, onFilter, baseFilter, filterValues, mainFiltersCount } = props;
  const [openFilterBox, setOpenFilterBox] = React.useState(true);
  const [moreFilter, setMoreFilter] = useState(false);

  const { register, handleSubmit, control, setValue, getValues, watch, reset } =
    useForm<any>();

  useEffect(() => {
    props.filters.map((item: any) => {
      if (item.type === 'date-picker-time' || item.type === 'date-picker') {
        register({ name: item.id }, { required: false });
      }
    });
  }, [register]);

  useEffect(() => {
    props.filters.map((item: any) => {
      setValue(item.id, filterValues[item.id]);
    });
  }, [openFilterBox]);

  // const handleSubmit = (e: React.FormEvent<HTMLInputElement>) => {
  //   e.preventDefault();
  // };
  const handleChange = (event: any) => {
    setCheckboxValue(event.target.value);
  };






  const renderFromItems = (filters: Record<string, any>[], props: any) => {
    const values = flattenObject(getValues());
    return filters.map(
      (
        item: any, //todo type
        index: number
      ) => (
        <Grid
          className={classes.root}
          container
          item
          spacing={1}
          xs={
            index === 0 &&
              props.name !== 'فروشندگان' &&
              props.name !== 'تامین کننده ها'
              ? 12
              : 6
          }
          key={index}
        >
          {item.type === 'input' && (
            <Grid item xs={12}>
              <TextField
                size="small"
                variant="outlined"
                inputRef={register({ required: false })}
                name={item.id}
                label={item.label}
                fullWidth
                // className={classes.textInput}
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'number' && (
            <Grid item xs={12}>
              <TextField
                size="small"
                variant="outlined"
                inputRef={register({ required: false })}
                name={item.id}
                label={item.label}
                type={item.type}
                // className={classes.textInput}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'date-picker' && (
            <Grid item xs={12} spacing={1} className={classes.inputWrapper}>
              <Controller
                style={{ width: '100%' }}
                name={item.id}
                control={control}
                rules={{ required: false }}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      size="small"
                      inputVariant="outlined"
                      inputRef={register({ required: false })}
                      fullWidth
                      autoOk
                      variant="inline"
                      label={item.label}
                      // className={classes.textInput}
                      format="YYYY/MM/DD"
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid() ? date.format('jYYYY/jMM/jDD') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                          convertPersianDigit2English(
                            value.format('YYYY-MM-DD')
                          )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'time-picker' && (
            <Grid item xs={12} className={classes.inputWrapper}>
              <Controller
                style={{ width: '100%' }}
                name={item.id}
                control={control}
                rules={{ required: false }}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <TimePicker
                      size="small"
                      inputVariant="outlined"
                      fullWidth
                      label={item.label}
                      variant="inline"
                      ampm={false}
                      format="HH:mm"
                      // className={classes.textInput}
                      autoOk
                      clearable
                      labelFunc={date =>
                        date?.isValid() ? date.format('HH:mm') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                          convertPersianDigit2English(
                            value.format('jYYYY/jMM/jDD HH:mm')
                          )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'date-picker-time' && (
            <Grid item xs={12} className={classes.inputWrapper}>
              <Controller
                style={{ width: '100%' }}
                name={item.id}
                control={control}
                rules={{ required: false }}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DateTimePicker
                      size="small"
                      inputVariant="outlined"
                      inputRef={register({ required: false })}
                      fullWidth
                      label={item.label}
                      variant="inline"
                      format="YYYY/MM/DD HH:mm"
                      autoOk
                      // className={classes.textInput}
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid()
                          ? date.format('jYYYY/jMM/jDD HH:mm')
                          : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value && convertPersianDigit2English(value.format())
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}
          {item.type === 'select' && (
            <Grid item xs={12} className={classes.inputWrapper}>
              <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor={item.id}>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{ required: false }}
                  render={({ onChange, value }) => (
                    <Select
                      size="small"
                      variant="outlined"
                      inputRef={register({ required: false })}
                      fullWidth
                      name={item.id}
                      // className={classes.textInput}
                      onChange={e => {
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id] || ''}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                    >
                      <MenuItem aria-label="None" value="" />
                      {item.data.map((itemD: any, index: number) => (
                        <MenuItem value={itemD} key={index}>
                          {item.translateType === 'Order'
                            ? translate(itemD, 'order')
                            : item.translateType === 'UserRole'
                              ? translate(itemD, 'user')
                              : item.translateType === 'ParcelsStatus'
                                ? translate(itemD, 'parcel')
                                : item.translateType === 'FleetStatus'
                                  ? translate(itemD, 'fleet')
                                  : item.translateType === 'VehicleType'
                                    ? translate(itemD)
                                    : item.translateType === 'TransactionType'
                                      ? translate(itemD)
                                      : item.translateType === 'TPL'
                                        ? translate(itemD, 'TPL')
                                        : item.translateType === 'OrderBundleStatus'
                                          ? translate(itemD, 'order')
                                          : item.translateType === 'EmploymentStatus'
                                            ? translate(itemD, 'driver')
                                            : item.translateType === 'COD'
                                              ? translate(itemD, 'cod')
                                              : translate(itemD, 'bundle')}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
          {item.type === 'checkbox' && (
            <Grid xs={12} item className={classes.inputWrapper}>
              <FormControl style={{ width: '97.5%' }}>
                <InputLabel
                  id={item.id}
                  style={{ padding: '0 16px', marginTop: '-7px' }}
                >
                  {item.label}
                </InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{ required: false }}
                  render={({ onChange, value }) => (
                    <Select
                      variant="outlined"
                      inputRef={register({ required: false })}
                      label={item.label}
                      labelId={item.id}
                      id={item.id}
                      multiple
                      // className={classes.textInput}
                      onChange={e => {
                        handleChange(e);
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id]?.split(',') || []}
                      // input={<Input />}
                      name={item.id}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                      renderValue={(selected: any) => {
                        const nameSelectedItem = item.data.filter(
                          (status: any) => {
                            return selected.includes(status);
                          }
                        );

                        return nameSelectedItem
                          .map((nameSelect: any) =>
                            item.translateType === 'Order'
                              ? translate(nameSelect, 'order')
                              : item.translateType === 'UserRole'
                                ? translate(nameSelect, 'user')
                                : item.translateType === 'Category'
                                  ? nameSelect
                                  : item.translateType === 'CenterStatus'
                                    ? translate(nameSelect, 'center')
                                    : item.translateType === 'ParcelsStatus'
                                      ? translate(nameSelect, 'parcel')
                                      : item.translateType === 'TPL'
                                        ? translate(nameSelect, 'TPL')
                                        : item.translateType === 'OrderBundleStatus'
                                          ? translate(nameSelect, 'order')
                                          : item.translateType === 'FleetType'
                                            ? translate(nameSelect, 'fleet')
                                            : item.translateType === 'COD'
                                              ? translate(nameSelect, 'cod')
                                              : translate(nameSelect, 'bundle')
                          )
                          .join(',');
                      }}
                      MenuProps={MenuProps}
                    >
                      {item.data.map((itemD: any) => (
                        <MenuItem key={itemD} value={itemD}>
                          <Checkbox
                            size="small"
                            checked={
                              checkboxValue.indexOf(itemD) > -1 ||
                              values[item.id]?.indexOf(itemD) > -1
                            }
                          />
                          <ListItemText
                            primary={
                              // Todo
                              item.translateType === 'Order'
                                ? translate(itemD, 'order')
                                : item.translateType === 'UserRole'
                                  ? translate(itemD, 'user')
                                  : item.translateType === 'Category'
                                    ? itemD
                                    : item.translateType === 'CenterStatus'
                                      ? translate(itemD, 'center')
                                      : item.translateType === 'ParcelsStatus'
                                        ? translate(itemD, 'parcel')
                                        : item.translateType === 'TPL'
                                          ? translate(itemD, 'TPL')
                                          : item.translateType === 'OrderBundleStatus'
                                            ? translate(itemD, 'order')
                                            : item.translateType === 'FleetType'
                                              ? translate(itemD, 'fleet')
                                              : item.translateType === 'COD'
                                                ? translate(itemD, 'cod')
                                                : translate(itemD, 'bundle')
                            }
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>
      )
    );
  };

  const clearForm = (props?: any) => {
    setCheckboxValue([]);
    props.onFilter({});
  };

  const renderInitialValues = (items: Filter[]) => {
    const initialValues: any = {};
    items.map((filter: Filter) => (initialValues[filter.id] = null));
    setInit(initialValues);
  };

  const onSubmit = (data: any) => {
    props.onFilter(data);
    setOpenFilterBox(false);
    props.toggleList();
  };

  return (
    <div className={classes.container}>
      <Grid
        item
        xs={12}
        container
        style={{ display: 'flex', justifyContent: 'space-around' }}
      >
        <div
          className={classes.searchBox}
          style={openFilterBox ? { width: '100%' } : { width: '75%' }}
        >
          <Grid
            container
            style={{ flexGrow: 2, maxWidth: '100%', margin: 0 }}
            item
            spacing={1}
            xs={12}
            sm={6}
          >
            <form style={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)}>
              <Grid
                style={{ marginRight: 0, marginLeft: 0, flexDirection: 'row' }}
                container
                item
                spacing={1}
                alignItems={'center'}
                xs={12}
              >
                <Grid item>
                  <IconButton
                    type="submit"
                    className={classes.iconButton1}
                    aria-label="search"
                  >
                    <Icon
                      path={mdiMagnify}
                      size={1}
                      className={classes.magnifyIcon}
                    />
                  </IconButton>
                </Grid>
                {baseFilter.type === 'input' && (
                  <Grid item style={{ flexGrow: 2 }}>
                    <InputBase
                      inputRef={register({ required: false })}
                      name={baseFilter.id}
                      placeholder={baseFilter.placeholder}
                      fullWidth
                      defaultValue={null}
                    />
                  </Grid>
                )}

                {baseFilter.type === 'number' && (
                  <Grid item style={{ flexGrow: 2 }}>
                    <InputBase
                      inputRef={register({ required: false })}
                      name={baseFilter.id}
                      placeholder={baseFilter.placeholder}
                      type={baseFilter.type}
                      fullWidth
                    />
                  </Grid>
                )}
                {Object.keys(filterValues).length > 3 + mainFiltersCount && (
                  <IconButton
                    className={classes.iconButton}
                    aria-label="cancelFilter"
                    onClick={() => {
                      onFilter({ page: 0, size: 10 });
                      reset({});
                    }}
                    title="پاک کردن فیلتر"
                    data-cy="cancelFilter"
                  >
                    <Icon
                      path={mdiClose}
                      size={1}
                      className={classes.closeIcon}
                    />
                  </IconButton>
                )}
              </Grid>
            </form>
          </Grid>

          <div>
            {openFilterBox ? (
              <form onSubmit={handleSubmit(onSubmit)}>
                <div
                  className={clsx(classes.filterBox, {
                    [classes.filterOpen]: openFilterBox,
                  })}
                >
                  <Button
                    onClick={() => props.toggleList(setOpenFilterBox(false))}
                    style={{
                      color: '#217aff',
                      width: '100%',
                      textAlign: 'left',
                      justifyContent: 'left',
                      marginBottom: '10px',
                    }}
                  >
                    <Typography component="h2">
                      مشاهده همه {props.name}
                    </Typography>
                    <Icon
                      path={mdiChevronLeft}
                      size={1}
                      style={{
                        color: '#217aff',
                      }}
                    />
                  </Button>
                  <Grid
                    container
                    spacing={checkMatchMedia('(max-width: 768px)') ? 1 : 3}
                  >
                    {openFilterBox && renderFromItems(filters, props)}

                    {/* <IconButton
                      onClick={() => setMoreFilter(true)}
                      style={{color: '#217aff', marginTop: '10px'}}
                    >
                      <Typography component="h2">مشاهده همه فیلترها</Typography>
                      <Icon
                        path={mdiPlus}
                        size={1}
                        style={{
                          color: '#217aff',
                          marginRight: '8px',
                        }}
                      />
                    </IconButton> */}

                    <Divider style={{ width: '100%', margin: '10px 0' }} />
                    <Grid
                      xs={12}
                      item
                      style={{
                        marginTop: '4px',
                        marginBottom: '4px',
                        marginRight: 'auto',
                      }}
                    >
                      {/* <div style={{display: 'flex', flexGrow: 1}} /> */}

                      <div style={{ padding: '0 5px' }}>
                        <Button
                          fullWidth
                          type="submit"
                          variant="contained"
                          color="primary"
                          autoFocus
                          size="large"
                          data-cy="search"
                          disabled={
                            Object.keys(
                              flattenObject(removeEmptyValueObject(watch()))
                            ).length === 0
                          }
                        >
                          {'اعمال فیلترها'}
                          {false && <CircularProgress size={24} />}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </form>
            ) : null}
          </div>
        </div>
        {!openFilterBox && (
          <div
            style={{
              backgroundColor: 'rgba(47, 72, 88, 0.2)',
              border: 'solid 1px gray',
              color: '#2f4858',
              borderRadius: '5px',
              paddingTop: '5px',
            }}
          >
            <Button
              onClick={() => props.toggleList(setOpenFilterBox(!openFilterBox))}
            >
              <Icon path={mdiTuneVerticalVariant} size={1} />
              فیلترها
            </Button>
          </div>
        )}

        {/* <Divider /> */}
      </Grid>
    </div>
  );
}

export default RenderFilters;
